"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFlashlight = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconFlashlight = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.634 22.425V11.121l-2.05-3.05V1.825h12.5v6.246l-2.05 3.05v11.304h-8.4Zm4.198-6.65c-.445 0-.822-.156-1.133-.467a1.548 1.548 0 0 1-.465-1.135c0-.445.156-.822.467-1.132.312-.31.69-.466 1.135-.466.445 0 .822.156 1.133.467.31.312.465.69.465 1.135 0 .445-.156.822-.467 1.133a1.55 1.55 0 0 1-1.135.465ZM7.734 4.925h8.2v-.95h-8.2v.95Zm8.2 2.15h-8.2v.35l2.05 3.06v9.79h4.1v-9.79l2.05-3.06v-.35Z"
}));
exports.IconFlashlight = IconFlashlight;
//# sourceMappingURL=IconFlashlight.js.map